import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Paper } from 'shared/ui/paper'

import { InsuranceCountry } from '../../../../model/types'

import s from './styles.module.scss'

interface CountryCardProps {
  country: InsuranceCountry | null
  onSelect: () => void
}

export const CountryCard: FC<CountryCardProps> = ({ country, onSelect }) => {
  const { t, i18n } = useTranslation()

  return (
    <Paper
      className={s.card}
      padding={[20, 16]}
      radius="20px"
    >
      <h1 className={clsx(s.title, 'bold-17')}>
        {t('insurance.vzr.country.label')}
      </h1>
      <div className={s.countryField}>
        <button
          type="button"
          className={s.selectButton}
          onClick={onSelect}
        >
          <span className={clsx('medium-16', !country && s.placeholder)}>
            {(i18n.language === 'en' ? country?.nameEn : country?.nameRu) ||
              t('insurance.vzr.country.placeholder')}
          </span>
          <AppIcon
            id={AllIcons.ARROW_RIGHT}
            width={24}
            height={24}
          />
        </button>

        {country?.productName && (
          <p className={clsx(s.insuranceZone, 'medium-14')}>
            {t('insurance.vzr.country.insurance_zone', {
              zone: country.productName,
            })}
          </p>
        )}
      </div>
    </Paper>
  )
}
